import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationUpdatePMId } from "../../Services/Service";

// async thunk
export const updatePMS = createAsyncThunk(
  "pms/updatePMS",
  async ({ PID, BONRESID, PMSRESID }, { rejectWithValue }) => {
    try {
      const response = await ReservationUpdatePMId(
        PID,
        BONRESID,
        PMSRESID
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating PMS");
    }
  }
);

const reserPmsSlice = createSlice({
  name: "pms",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetPMSState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePMS.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updatePMS.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updatePMS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPMSState } = reserPmsSlice.actions;
export default reserPmsSlice.reducer;